export default __webpack_public_path__ + "static/konditour-fa47c56824cf3580369ea6c317c99aa0.jpg";